import {ServiceBase} from "../ServiceBase";
import {
  CallToActionFunc, ICreateSafezoneObjectParams,
  ISafezoneObject,
  ISafezoneObjectFactoryService, ReadyFunc
} from "./safezone-object-factory.service.interface";
import {
  IFullSafezoneHandler, IMiniSafezoneHandler,
  ISafezoneContext,
  ISafezoneInitParams,
  SAFEZONE_FUNCTION
} from "./safezone.service.interface";
import {Check} from "@sparkware/app-utils";
import {GetPlatformTokenResponse} from "../sdk/cgp-sdk.interface";
import {FullSafezoneHandler} from "./full-safezone-handler";
import {MiniSafezoneHandler} from "./mini-safezone-handler";

export class SafezoneObjectFactoryService extends ServiceBase implements ISafezoneObjectFactoryService{

    private _safezoneFunc = undefined;

    async createSafezoneObject(params:ICreateSafezoneObjectParams): Promise<ISafezoneObject> {

      this._safezoneFunc = await this._getSafezoneFunction();
      let initParams = await this._getInitParams(params.onCallToActionCallback, params.onReadyCallback);
      return this._safezoneFunc(initParams);
    }

    createFullSafezoneHandler():IFullSafezoneHandler{
      return new FullSafezoneHandler(this.services);
    }

    createMiniSafezoneHandler():IMiniSafezoneHandler{
      return new MiniSafezoneHandler( this.services);
     }

    private async _getSafezoneFunction():Promise<Function>{
      if(!Check.isNullOrUndefined(this._safezoneFunc)){
        return this._safezoneFunc;
      } else {
        await this.services.sdk.loadSafezoneSdk();
        const safeZoneFunction = this.services.window.getGlobalProperty(SAFEZONE_FUNCTION);
        if (Check.isFunction(safeZoneFunction)) {
          return safeZoneFunction;
        } else {
          throw new Error('Safezone is not a function or the function was not created on window');
        }
      }
    }

    private async _getInitParams(callToActionCallback:CallToActionFunc, onReadyCallback:ReadyFunc): Promise<ISafezoneInitParams> {
        let token:GetPlatformTokenResponse = await this.services.user.getPlatformToken();
        let contextObj: ISafezoneContext = {
          userInfo: token.token.toString(),
          brandId: this.services.sdk.getBrandID(),
          subBrandId: this.services.sdk.getSubBrandID(),
          productPackage: this.services.sdk.getProductPackageId(),
          systemId: this.services.sdk.getSkin().getPlatformSystemID(),
          lang: this.services.language.currentLanguage,
          clientPlatform: this.services.sdk.getSkin().getClientPlatform(),
          clientVersion: this.services.sdk.getSkin().getVersion(),
          locale: this.services.sdk.getSkin().getCulture(),
          fontDomain: this.services.configuration.getFontsPath()
        };
        return {
          context: contextObj,
          onReady: onReadyCallback,
          onError: () => {},
          onCallToAction: callToActionCallback
        };
    }
}